import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import AuthProvider from './providers/AuthProvider';
import LazyRoute from './components/LazyRoute';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home/Home';
import ErrorFallbackPage from './pages/ErrorFallback';
import MenuProvider from './providers/MenuProvider';

const CreateGame = React.lazy(() => import('./pages/CreateGame/CreateGame'));
const JoinGame = React.lazy(() => import('./pages/JoinGame'));
const Game = React.lazy(() => import('./pages/Game'));
const LoginPage = React.lazy(() => import('./pages/Login'));
const Admin = React.lazy(() => import('./pages/Admin'));
const AddQuestionsJson = React.lazy(
  () => import('./pages/Admin/pages/AddQuestionsJson')
);
const CreateQuestion = React.lazy(
  () => import('./pages/Admin/pages/CreateQuestion')
);
const DashboardPage = React.lazy(() => import('./pages/Admin/pages/Dashboard'));
const GameLogsPage = React.lazy(() => import('./pages/Admin/pages/GameLogs'));
const Games = React.lazy(() => import('./pages/Admin/pages/Games'));
const QuestionsOverview = React.lazy(
  () => import('./pages/Admin/pages/QuestionsOverview')
);
const FeedbackPage = React.lazy(() => import('./pages/Feedback'));
const SubmitQuestionPage = React.lazy(() => import('./pages/SubmitQuestion'));

const AboutPage = React.lazy(() => import('./pages/About'));
const HowToPlayPage = React.lazy(() => import('./pages/HowToPlay'));
const LegalNoticePage = React.lazy(() => import('./pages/LegalNotice'));

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => <ErrorFallbackPage reset={resetError} />}
    >
      <AuthProvider>
        <MenuProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route element={<LazyRoute />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/game/create" element={<CreateGame />} />
                <Route path="/game/join" element={<JoinGame />} />
                <Route path="/game/:id" element={<Game />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route
                  path="/frage-einreichen"
                  element={<SubmitQuestionPage />}
                />
                <Route path="/ueber-uns" element={<AboutPage />} />
                <Route path="/wie-spielt-man" element={<HowToPlayPage />} />
                <Route path="/impressum" element={<LegalNoticePage />} />
              </Route>

              <Route element={<ProtectedRoute />}>
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/games" element={<Games />} />
                <Route
                  path="/admin/questions"
                  element={<QuestionsOverview />}
                />
                <Route
                  path="/admin/create-question"
                  element={<CreateQuestion />}
                />
                <Route
                  path="/admin/add-questions-json"
                  element={<AddQuestionsJson />}
                />
                <Route path="/admin/dashboard" element={<DashboardPage />} />
                <Route path="/admin/gamelogs" element={<GameLogsPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </MenuProvider>
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
